<template>
  <div class="Inicio">
    <div class="col-sm-8 col-md-6 col-lg-5 col-center">
      <img src="../assets/logo_portrait.png" style="margin-left: auto; margin-right: auto; display: block;" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: "Inicio",
  methods: {},
  data() {
    return {
      value: null
    };
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  }
};
</script>